import { PRODUCTION } from "@irati/utils/constants/environment";
import env from "@irati/utils/env";
export var getBrazeKey = function () {
    if (env.ENVIRONMENT_NAME === PRODUCTION) {
        return "48fae39e-66d6-425d-ac0c-b5940ec4a609";
    }
    return "656bc815-77b1-445f-9752-c7defacef0f1";
};
export var baseUrl = "https://sdk.fra-01.braze.eu/api/v3";
